import styled from 'styled-components';

import { device, hexToRGB } from '@/styles/helpers';

interface ScLootboxModalProps {
  bgImage: string;
}

export const ScLootboxModal = styled.div<ScLootboxModalProps>`
  position: relative;
  overflow: hidden;
  margin: 50px auto;
  max-width: 640px;
  width: 100%;
  padding: 32px;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;

  background-image: ${({ bgImage }) => `url(${bgImage})`};
  background-position: top center;
  background-size: cover;

  & > .character {
    width: 68%;
    max-width: 396px;
    height: auto;
  }

  & > .info-block {
    width: 100%;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px;
    gap: 24px;
    background-color: ${({ theme }) => hexToRGB(theme.blackColor, 0.8)};
    text-align: center;
    color: ${({ theme }) => theme.whiteColor};
    backdrop-filter: blur(5px);

    & > .title {
      font-weight: 700;
      font-size: 32px;
      line-height: 1.25;
      letter-spacing: 0.03em;
      text-transform: uppercase;
    }

    & > .text {
      font-size: 16px;
      line-height: 1.5;
      font-weight: 400;
    }

    & > .lootboxes-container {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: auto;
      gap: 8px;
      justify-content: center;
      flex-wrap: wrap;
    }
  }

  @media (${device.mobile}) {
    min-height: 100vh;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
    padding: 45px 8px 16px;

    & > .info-block {
      padding: 32px 16px;
      & > .title {
        font-size: 28px;
        line-height: 1.29;
      }
    }
  }
`;
